import {
  entityValidationPlugin,
  EntityValidationPage,
} from '@backstage-community/plugin-entity-validation';
import { convertLegacyPlugin, convertLegacyPageExtension } from '@backstage/core-compat-api';

export const entityValidationConverted = convertLegacyPlugin(entityValidationPlugin, {
  extensions: [
    convertLegacyPageExtension(EntityValidationPage, { 
      path: '/entity-validation',
      name: 'Entity Validation',
    }),
  ],
});